import { Link } from "react-router-dom";
import { Stamp } from "@/components/Doc";

const Rule = () => <div className="border-t border-carbon my-5" />;

const Row = ({ k, v, testId }) => (
  <div className="grid grid-cols-[130px_1fr] sm:grid-cols-[180px_1fr] gap-3 py-1.5">
    <span className="t-label text-olive">{k}</span>
    <span className="t-body text-base sm:text-lg" data-testid={testId}>{v}</span>
  </div>
);

export const Report = ({ report }) => {
  const r = report;
  return (
    <article className="report-sheet bg-paper border border-carbon p-6 sm:p-12 max-w-3xl mx-auto shadow-[6px_6px_0_0_#D9C9A8]" data-testid="findings-report">
      <header className="flex justify-between items-start">
        <div>
          <div className="t-head text-3xl tracking-[0.08em]">LONGHAND</div>
          <div className="t-label text-olive mt-1">Preliminary Findings</div>
        </div>
        <div className="text-right">
          <div className="t-label">Form LH-90</div>
          <div className="t-label text-olive mt-1" data-testid="report-date">{r.date}</div>
        </div>
      </header>
      <Rule />
      <Row k="Prepared for:" v={`${r.prepared_for.name}, ${r.prepared_for.company}`} testId="report-prepared-for" />
      <div className="grid grid-cols-[130px_1fr] sm:grid-cols-[180px_1fr] gap-3 py-1.5 items-center">
        <span className="t-label text-olive">Classification:</span>
        <span><Stamp color="red" rotate={-4} size="lg" testId="report-band-stamp">{r.band}</Stamp></span>
      </div>
      <Row k="Total exposure:" v={`${r.total} of 80`} testId="report-total" />
      <Rule />

      <p className="t-body text-lg sm:text-xl leading-[1.65]" data-testid="report-verdict">{r.verdict}</p>

      <h3 className="t-label mt-10 mb-4 rule-label"><span>Exposure by domain</span></h3>
      <div className="flex flex-col gap-5">
        {r.domains.map((d) => (
          <div key={d.module} data-testid={`domain-${d.module}`}>
            <div className="flex justify-between t-label mb-1.5">
              <span>{d.numeral} — {d.name}</span>
              <span className="text-olive">{d.score} / {d.max}</span>
            </div>
            <div className="exposure-track"><div className="exposure-fill" style={{ width: `${Math.round((d.score / d.max) * 100)}%` }} /></div>
            <p className="t-body text-base text-olive mt-1.5">{d.reading}</p>
          </div>
        ))}
      </div>

      {r.commentary && (
        <>
          <h3 className="t-label mt-10 mb-4 rule-label"><span>Registrar's commentary</span></h3>
          <div className="t-body text-lg leading-[1.65] space-y-4" data-testid="report-commentary">
            {r.commentary.split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </>
      )}

      <h3 className="t-label mt-10 mb-4 rule-label"><span>Recommended sequence</span></h3>
      <p className="t-body text-lg leading-[1.65]" data-testid="report-recommended">
        <strong className="font-semibold">Module {r.recommended.numeral} — {r.recommended.name} first.</strong> {r.recommended.install}
      </p>

      <h3 className="t-label mt-10 mb-4 rule-label"><span>Findings</span></h3>
      <div className="flex flex-col gap-4">
        {r.findings.map((f, i) => (
          <div key={i} className="grid grid-cols-[100px_1fr] sm:grid-cols-[130px_1fr] gap-3" data-testid={`finding-${i + 1}`}>
            <span className="t-label pt-1">Finding {String(i + 1).padStart(2, "0")}</span>
            <div>
              <p className="t-body text-lg leading-snug">{f.finding}</p>
              <p className="t-mono text-sm text-olive mt-1">{f.remedy}</p>
            </div>
          </div>
        ))}
      </div>

      <Rule />
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <span className="t-label text-olive max-w-xs">Originated by Longhand — Operating practice from before the machine</span>
        <Link to="/contact" className="btn btn-stamp no-print" data-testid="report-book-call-btn">Book a Scoping Call</Link>
      </div>
    </article>
  );
};
